import { createSlice } from '@reduxjs/toolkit'
import { createFeedback, fetchFeedbacks } from './action'
import { FeedbackState } from './types'

const initialState: FeedbackState = {
  loading: false,
  loadingCreateFeedback: false,
  loadingFetchFeedbacks: false,

  feedback: [],
  error: null,
  errorCreateFeedback: '',
  errorFetchFeedbacks: '',
}

const manageFeedbackSlice = createSlice({
  name: 'manageFeedback',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFeedback.pending, (state) => {
        state.loadingCreateFeedback = true
        state.errorCreateFeedback = ''
      })
      .addCase(createFeedback.fulfilled, (state, action) => {
        state.loadingCreateFeedback = false
        state.feedback.push(action.payload)
      })
      .addCase(createFeedback.rejected, (state, action) => {
        state.loadingCreateFeedback = false
        state.errorCreateFeedback = action.error.message || 'Error creating feedback'
      })
      .addCase(fetchFeedbacks.pending, (state) => {
        state.loadingFetchFeedbacks = true
        state.errorFetchFeedbacks = ''
      })
      .addCase(fetchFeedbacks.fulfilled, (state, action) => {
        state.loadingFetchFeedbacks = false
        state.feedback = action.payload
      })
      .addCase(fetchFeedbacks.rejected, (state, action) => {
        state.loadingFetchFeedbacks = false
        state.errorFetchFeedbacks = action.error.message || 'Error fetching feedback'
      })
  },
})

export default manageFeedbackSlice.reducer
